<div class="sk-page">

  <!-- Hero-Kopf -->
  <div class="sk-hero">
    <div class="sk-hero-avatar"><mat-icon>badge</mat-icon></div>
    <div class="sk-hero-info">
      <h1>Stammkunden</h1>
      <div class="sk-hero-sub">
        <span>Schlüsselkunden mit eigener Personen-Einsatzplanung</span>
      </div>
    </div>
    <span class="sk-hero-spacer"></span>
    <div class="sk-hero-actions">
      <button mat-raised-button class="sk-btn-light" *ngIf="canCreate" (click)="openCreate()">
        <mat-icon>add</mat-icon> Neuer Stammkunde
      </button>
    </div>
  </div>

  <!-- Suche -->
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Suchen</mat-label>
    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()"
           placeholder="Name, Adresse, Kontakt…">
    <mat-icon matPrefix>search</mat-icon>
    <button mat-icon-button matSuffix *ngIf="searchTerm" (click)="searchTerm=''; applyFilter()" aria-label="Suche löschen">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <div class="sk-loading" *ngIf="loading">
    <mat-spinner diameter="42"></mat-spinner>
  </div>

  <!-- Leerzustand -->
  <div class="sk-empty" *ngIf="!loading && filtered.length === 0">
    <div class="sk-empty-icon"><mat-icon>badge</mat-icon></div>
    <p *ngIf="stammkunden.length === 0">Noch keine Stammkunden angelegt.<br>
      <span class="sk-muted">Ein Stammkunde bekommt ein eigenes Team, verknüpfte Lager und eine eigene Einsatzplanung.</span>
    </p>
    <p *ngIf="stammkunden.length > 0">Keine Treffer für die Suche.</p>
    <button mat-raised-button color="primary" *ngIf="canCreate && stammkunden.length === 0" (click)="openCreate()">
      <mat-icon>add</mat-icon> Ersten Stammkunden anlegen
    </button>
  </div>

  <!-- Karten -->
  <div class="card-grid" *ngIf="!loading">
    <div class="sk-card sk-card-hover kunde-card" *ngFor="let c of filtered; trackBy: trackById" (click)="open(c)">
      <div class="card-row">
        <div class="avatar" *ngIf="!c.logoPath">{{c.name.charAt(0).toUpperCase()}}</div>
        <div class="logo" *ngIf="c.logoPath">
          <img [src]="getLogoUrl(c.logoPath)" alt="Logo">
        </div>
        <div class="info">
          <h3>{{c.name}}</h3>
          <span class="line" *ngIf="c.address"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{c.address}}</span>
          <span class="line" *ngIf="c.contactPersonName"><mat-icon class="sk-inline-icon">person</mat-icon>{{c.contactPersonName}}</span>
        </div>
      </div>
      <div class="card-actions">
        <button mat-stroked-button (click)="openPlanung(c, $event)">
          <mat-icon>calendar_view_week</mat-icon> Planungsboard
        </button>
        <span class="sk-spacer"></span>
        <button mat-button color="primary">
          Öffnen <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
